import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useNavigate } from 'react-router-dom';
import { Terms } from '../../components/Terms';
import { TemporaryBlocked } from '../../components/TemporaryBlocked';
import { Layout } from '../../../../components/Layout/Layout';
import { InviteStepHeader } from '../../components/InviteStepHeader';
import { AdminForm } from './components/AdminForm';
import { AccountantForm } from './components/AccountantForm';
import { InviteStepFooter } from '../../components/InviteStepFooter';
import { InviteBaseFormType } from './schemes/baseScheme';
import { RoleType } from '../../../../types';
import { useTeamMemberDetailsPageLogic } from './useTeamMemberDetailsPageLogic';
import { VIEWS_MAP } from '../../../../router/constants';

export type InviteFormType = InviteBaseFormType;

export const InviteFormStep = () => {
  const {
    onSubmit,
    roleType,
    formMethods,
    isValid,
    isLoading,
    hideTermsModal,
    selectedTermsDoc,
    setIsTempBlock,
    isTempBlock,
    inviteFlowTexts,
    inviteName,
    inviteEmail,
    onTermsClick,
  } = useTeamMemberDetailsPageLogic();
  const navigate = useNavigate();
  const { t } = useTranslation('inviteEN');
  return (
    <Layout
      shouldHideProfile
      shouldHideChatBot
      wrapperClassName='fixed w-full flex flex-col justify-between z-[9999] bg-surface-primary-bw-00 h-full  justify-between'
    >
      <div className='h-full flex flex-col justify-between w-full '>
        <div id='snapShotSelector' className='flex flex-col items-center'>
          <InviteStepHeader onBackClick={() => navigate(`/${VIEWS_MAP.INVITE_ACCOUNTANT.INVITE}`)} />
          <div className=' w-full flex flex-col items-center max-w-[520px] mt-[132px]'>
            <Heading.H6 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary'>
              {inviteFlowTexts.title}
            </Heading.H6>
            <Heading.H9 className='mb-[50px] mt-[8px] text-text-main-secondary'>{inviteFlowTexts.subtitle}</Heading.H9>
            <Heading.H9 className='w-full mb-[8px] text-text-main-primary'>{inviteFlowTexts.formTitle}</Heading.H9>

            {roleType === RoleType.ADMIN && <AdminForm formMethods={formMethods} onTermsClick={onTermsClick} />}
            {roleType === RoleType.ACCOUNTANT && (
              <AccountantForm formMethods={formMethods} onTermsClick={onTermsClick} />
            )}
          </div>
        </div>
        <InviteStepFooter
          onClick={onSubmit}
          buttonTitle={t('INVITE_FORM.CTA')}
          disabled={!isValid || isLoading}
          isLoading={isLoading}
        />
      </div>
      {selectedTermsDoc && (
        <Terms
          inviteEmail={inviteEmail}
          inviteName={inviteName || ''}
          onClose={() => hideTermsModal()}
          type={selectedTermsDoc}
        />
      )}
      {isTempBlock && <TemporaryBlocked onClose={() => setIsTempBlock(false)} />}
    </Layout>
  );
};
